import { useAppSelector } from "../../../redux/store/hooks";
import { PLATFORM } from "../../../config/platform";

/**
 * The dashboard shown when this product has registered no home for the
 * signed-in role (see `domainRoleHomes` in config/domain-config.tsx).
 *
 * A template needs *a* landing page that works before any domain exists —
 * otherwise a fresh project renders a blank route or, worse, crashes on a
 * missing component. Every product is expected to replace this with something
 * that actually reports on its own data.
 */
const PlatformHome = () => {
  const user = useAppSelector((s) => s.layout.user);
  const organization = useAppSelector((s) => s.layout.organization);

  return (
    <div className="dashboard">
      <section className="panel">
        <div className="panel__head">
          <div>
            <h2>Welcome{user?.name ? `, ${user.name}` : ""}</h2>
            <p className="panel__sub">
              {organization?.name
                ? `Signed in to ${organization.name}`
                : `Signed in to ${PLATFORM.platform_name}`}
            </p>
          </div>
        </div>
        <div className="panel__body">
          <p className="panel__sub">
            No dashboard has been set up for your role yet. Register one in{" "}
            <code>src/config/domain-config.tsx</code> under{" "}
            <code>domainRoleHomes</code>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PlatformHome;
